import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	height: 100%;
	width: 100%;
	background-color: ${colors.greyBg};
	display: flex;
`;

export const StepSection = styled.div`
	width: 100%;
	overflow-y: auto;
`;

export const StepFormWrapper = styled.div`
	margin: 32px;
`;

export const Text = styled.div`
	ul {
		padding: 10px 10px 10px 40px;
	}

	li {
		list-style: initial;
	}
`;